import React, { Component } from 'react'
import { Button, Table, message } from 'antd'
import { CreateEnquiry } from './CreateEnquiry'
import { Client } from 'fulcrum-app'
import moment from 'moment'
import update from 'react-addons-update';
// import Map from './ListofEnquirysMap'
import * as columns from '../columns'

const client = new Client(process.env.REACT_APP_SECRET_KEY)

export default class Enquiry extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      lat: 0,
      lng: 0,
      enquiryList: [],
      selectedEnquiry: null
    }
    this.viewEnquiry = this.viewEnquiry.bind(this)
  }
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    const form = this.formRef.props.form;
    this.setState({
      visible: false,
      selectedEnquiry: null
    });
    form.resetFields()
  };
  onCreate = () => {
    const form = this.formRef.props.form;
    form.validateFields((err, values) => {
      if (err) { return }
      var obj = {
        form_id: 'e328b1d1-cd10-46d5-87d8-ace3f02a3344',
        status: 'Enquiry',
        form_values: {
          'ce91': moment(values.date).format('YYYY-MM-DD'),
          '6612': values.name,
          'c0bc': values.phone,
          'b89a': values.email,
          'c3f2': values.lat.toString(),
          '6aae': values.lng.toString(),
          'c2eb': {
            choice_values: [
              values.boreType
            ]
          },
          'ba02': values.address,
          '4aad': values.boreLicence,
          '85fa': values.depth,
          '29fd': values.information
        }
      }
      client.records.create(obj)
        .then(smth => console.log(smth))
        .catch(err => console.log(err))

      this.setState(prevState => ({
        enquiryList: [...prevState.enquiryList, {
          id: Math.random(),
          date: moment(values.date).format('YYYY-MM-DD'),
          name: values.name,
          phone: values.phone,
          email: values.email,
          address: values.address,
          boreType: values.boreType,
          lat: values.lat.toString(),
          lng: values.lng.toString()
        }]
      }))
      this.setState({ visible: false }, () => form.resetFields());
    })
  };
  onUpdate = (qualityPlan) => {
    const form = this.formRef.props.form;
    form.validateFields((err, values) => {
      if (err) { return }
      let previous = qualityPlan

      previous.form_values['ce91'] = moment(values.date).format('YYYY-MM-DD');
      previous.form_values['6612'] = values.name;
      previous.form_values['c0bc'] = values.phone;
      previous.form_values['b89a'] = values.email;
      previous.form_values['c3f2'] = values.lat.toString();
      previous.form_values['6aae'] = values.lng.toString();
      previous.form_values['c2eb'] = {
        choice_values: [values.boreType]
      }
      previous.form_values['ba02'] = values.address;
      previous.form_values['4aad'] = values.boreLicence;
      previous.form_values['85fa'] = values.depth;
      previous.form_values['29fd'] = values.information;

      client.records.update(previous.id, previous)
        .then(smth => {
          let index = this.state.enquiryList.findIndex((element) => element.id === previous.id)
          this.setState({
            enquiryList: update(this.state.enquiryList, {
              [index]: {
                id: { $set: previous.id },
                date: { $set: moment(values.date).format('YYYY-MM-DD') },
                name: { $set: values.name },
                phone: { $set: values.phone },
                email: { $set: values.email },
                address: { $set: values.address },
                boreType: { $set: values.boreType },
                lat: { $set: values.lat.toString() },
                lng: { $set: values.lng.toString() },
              }
            })
          })
          message.success('Updated client enquiry.',3)
        })
        .catch(err => {
          message.success('An error occured.',3)

          console.log(err)
        })

      this.setState({ visible: false, selectedEnquiry: null }, () => form.resetFields());
    })
  };
  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.QualityPlans !== this.props.QualityPlans) {
      this.setState({
        enquiryList: []
      }, () => this.createEnquiryList())
    }
  }
  componentDidMount() {
    this.createEnquiryList()
  }
  createEnquiryList() {
    this.props.QualityPlans.forEach(plan => {
      if (plan.form_values['6612']) {
        this.setState(prevState => ({
          enquiryList: [...prevState.enquiryList, {
            id: plan.id,
            date: plan.form_values['ce91'],
            name: plan.form_values['6612'],
            phone: plan.form_values['c0bc'],
            email: plan.form_values['b89a'],
            address: plan.form_values['ba02'],
            boreType: plan.form_values['c2eb'].choice_values[0],
            lat: plan.form_values['c3f2'],
            lng: plan.form_values['6aae']
          }]
        }))
      }
    })
  }
  viewEnquiry(val) {
    this.setState({
      visible: true,
      selectedEnquiry: val
    });
  }
  render() {
    return (
      <div>
        <h2>Enquirys</h2>
        <Button type="primary" onClick={this.showDrawer} ghost style={{ marginBottom: 15 }}>
          New Client Enquiry
        </Button>
        <Table
          pagination={{ position: 'bottom', pageSize: 10 }}
          bordered
          id='postTable'
          className='tableResizer'
          columns={columns.ENQUIRY(this.viewEnquiry)}
          dataSource={this.state.enquiryList}
          rowKey='id'
          size="middle"
        />
        <CreateEnquiry
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.visible}
          onClose={this.onClose}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          viewEnquiry={this.state.selectedEnquiry} />
      </div>
    )
  }
}



